var _image;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightburst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 76,
    viewBox: "0 0 52 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 52,
    height: 76,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABMCAYAAAAiCZRHAAAC80lEQVRoge2bwVHrMBCGN5pXQErw6yB0YDpIDr5DB8nJR+DoU9JBeGcfSAmhAugglOAKPG/0+A3Csv0saeXIM/ouzEgGs/OvtCvvakETIMp8SUR7IkqJ6KbOisrXW4U2wv2CMl8T0YWI7ogoIaIH7SFGvCkEVY5EtNYmiW7rrDhroxzv1UY4/ui3Kl3GENzPC6wKiTJPoEqqTeo81VnxqI06wmaQKPMt1sdSm+xHbhDvvbMW/GIwxESVNtL1brVRl/9HGzH55U9V3iyNkbxqI45YuZwo8xVUWWmT45Buds/tbmRjkCjzR8dY4mUzaBhtEIMqZ6jyoc0w8l+DECC3DqpUUOWgzUxtkCjzFKok2uQ4JlFFpdMgqPIAZWyYVJVBgxhUOUEVbxn1EF8GKSn+3cDzQ1Qw5DTwjHcW9J1MHg3TFpWrqqKycIwrcrHvrq2Kikx9nuEuphyQXAZjDCkutzU4o3zAvbwc0FxRN4W3EVnAAdvx1ddKH+rx4R6ZcxfvWCtBqqLyIw71bBBek0luugLrBUHVW4rvk64Tq3S9dE6qRCKRSCQSCk22vfJZEZiSJlNYOnzODQrvFbypiQaFTjQodKJBkUgkEolETCLtZ411trQ/1q9QgZjld23qSH2O+PnPMFHmexSTZ8OXQSiltAteWxg2GzdsPpIkcLUhNYKv3pGi0JiS/izUWhgWjBueUaIMTi3RUYIcg+w2uaBhIyikQRuU6k2RLvoiyvwlpJ1QoLJ9g0VvwzoktdqBdXb9cW1+BFYGtVLshLZ9ds5oZf0GqLXvCLZjuYpavQY19DRjjGXyzsZRXcFMHcG7KZJdo77t0Hu2ybIR3eWuA/k+mljfTrG8jaIS3nUbBrXkDrjhVMvp27bckuuskNdldpZtnolDEO+E80JUgrhlkgKd6qzYaKMOsF8qNGiZrtCEyxp42csp6BL+jV7uIZ58ZBFeL+YOqHXG2uN/pzbCiKKWmvpU6Jr0wiRXpyXK0eSPt2yBiP4CCg4K3lYpvZQAAAAASUVORK5CYII="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightburst);
export default __webpack_public_path__ + "static/media/rightburst.910ea6fe.svg";
export { ForwardRef as ReactComponent };